import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import NeroChar from "@/pages/NeroChar";
import Team from "@/pages/Team";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<NeroChar />} />
            <Route path="/team" element={<Team />} />
            <Route path="/agb" element={<LegalPage docKey="agb" />} />
            <Route path="/datenschutz" element={<LegalPage docKey="privacy" />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
